<template>
  <div>
    <div class="case-title">
      <div>{{ $t("ticket.list.ticket") }}</div>
      <div>
        <i-switch v-if="companyIdCookie == 1" v-model="aiStatus" :disabled="isDisable" size="large" @on-change="changeAiStatus">
          <span slot="open">AI</span>
          <span slot="close">人工</span>
        </i-switch>
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="['cases:case:export']"
          >{{ $t("common.export") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="['cases:case:import']"
          @click="importFile"
          >{{ $t("message.import") }}</Button
        >
      </div>
    </div>
    <div class="case-top">
      <case-search ref="caseSearchChild"></case-search>
    </div>
    <table-case></table-case>
    <!-- 导入 -->
    <import ref="import"></import>
  </div>
</template>

<script>
import CaseSearch from "../case/CaseSearch";
import TableCase from "../case/TableCase";
import Import from "./Import";
import {getCookie} from "../../../utils/cookieUtil";

var caseVue = {};

export default {
  name: "Case",
  components: {
    CaseSearch,
    TableCase,
    Import
  },
  data() {
    return {
      companyIdCookie: getCookie(global.companyId),
      modal_loading: false,
      ticketEntityId: "",
      priorityId: "",
      companyId: "",
      status: "",
      assigneeUserName: "",
      createdTime: "",
      ticketCategory: "",
      aiStatus: false,
      isDisable: false
    };
  },
  beforeCreate: function() {
    caseVue = this;
    this.$api.customerDefinedAlarmConfiguration.getAiStatus().then(res => {
      this.aiStatus = !res.data.data
    })
  },
  methods: {
    // 更新人工接管状态
    changeAiStatus() {
      this.$Modal.confirm({
        title: '提示',
        content: '确定修改接管状态吗?',
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          this.isDisable = true
          this.$api.customerDefinedAlarmConfiguration.updateAiStatus(!this.aiStatus).then(res => {
            this.$Message.success('更新成功')
          }).finally(() => {
            setTimeout(() => {
              this.isDisable = false
            }, 5000)
          })
        },
        onCancel: () => {
          this.aiStatus = !this.aiStatus
        }
      })
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "Loading ..."
      });
      // 获取子组件数据
      this.ticketEntityId = this.$refs.caseSearchChild.ticketEntityId;
      this.status = this.$refs.caseSearchChild.status;
      this.priorityId = this.$refs.caseSearchChild.priorityId;
      this.companyId = this.$refs.caseSearchChild.companyId;
      this.ticketCategory = this.$refs.caseSearchChild.ticketCategory;
      this.assigneeUserName = this.$refs.caseSearchChild.assigneeUserName;
      this.createdTime = this.$refs.caseSearchChild.createdTime;
      this.startTime = this.$refs.caseSearchChild.startTime;
      this.endTime = this.$refs.caseSearchChild.endTime;

      // 下载Excel 文件
      this.$api.ticket
        .exportTicket({
          ticketEntityId: this.ticketEntityId,
          companyId: this.companyId,
          status: this.status,
          priorityList: this.priorityId,
          assigneeUserName: this.assigneeUserName,
          createdTime: this.createdTime,
          ticketCategory: this.ticketCategory,
          startTime: this.startTime,
          endTime: this.endTime
        })
        .then(res => {
          let fileName = "TicketList.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    },
    // 导入
    importFile: function() {
      this.$nextTick(() => {
        this.$refs.import.init();
      });
    }
  }
};
</script>

<style scoped>
.case-title {
  width: 100%;
  font-size: 13px;
  background-color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
  overflow: hidden;
}
.case-title > div:nth-child(1) {
  float: left;
}
.case-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.case-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/cases/case/Case.vue